const topics = [
  { icon: 'ri-chat-smile-2-line', label: '今日吃瓜', desc: '娱乐圈最新爆料汇总', hot: true, color: 'accent' },
  { icon: 'ri-shopping-bag-3-line', label: '电商大促', desc: '618/双11优惠导航', hot: true, color: 'primary' },
  { icon: 'ri-gamepad-line', label: '游戏资讯', desc: '热门游戏攻略与排行', hot: false, color: 'secondary' },
  { icon: 'ri-film-line', label: '影视推荐', desc: '热播剧综追更入口', hot: true, color: 'accent' },
  { icon: 'ri-newspaper-line', label: '社会热点', desc: '全网热议事件追踪', hot: false, color: 'primary' },
  { icon: 'ri-lightbulb-line', label: '实用工具', desc: '在线工具一站直达', hot: false, color: 'secondary' },
  { icon: 'ri-bank-card-line', label: '投资理财', desc: '基金股票信息聚合', hot: false, color: 'primary' },
  { icon: 'ri-plane-line', label: '出行旅游', desc: '机票酒店比价导航', hot: true, color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">热门专题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            精选八大热门专题合集，覆盖吃瓜、购物、游戏、影视等高频场景，点击即达
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href={`#${topic.label}`}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              {topic.hot && (
                <span className="absolute top-2 right-2 bg-accent-500 text-background-50 text-[10px] font-semibold px-1.5 py-0.5 rounded-full">
                  HOT
                </span>
              )}
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl mb-3 transition-transform duration-200 group-hover:scale-110 ${
                topic.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                topic.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${topic.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-1">{topic.label}</h3>
              <p className="text-xs md:text-sm text-foreground-500">{topic.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}